// @ts-strict-ignore
import { Injectable, ViewContainerRef } from '@angular/core';
import { SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';
import { Observable, Subject } from 'rxjs';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMApplicationMenuUserContextDialogComponent } from './lm-application-menu-usercontext-dialog.component';
import { LMDialogButtonKey, LMUniqueIdService } from '@utils/index';

export enum LMApplicationMenuUserContextDialogStatus {
  RESPONSE_CANCEL = 0,
  RESPONSE_OK,
  RESPONSE_SAVED
}

export interface LMApplicationMenuUserContextResult {
  status: LMApplicationMenuUserContextDialogStatus;
  userContextFields?: LMBannerUserContextField[];
  userContextProperties?: { [ key: string ]: LMBannerUserContextModelField };
  saveChanges: boolean;
}

@Injectable()
export class LMApplicationMenuUserContextDialogService {

  constructor(
    private sohoModalDialogService: SohoModalDialogService,
    private lmLoggerService: LMLoggerService,
    private lmUniqueIdService: LMUniqueIdService
  ) {
  }

  /**
   * Prompt User Context dialog
   * @param viewContainerRef
   *
   * @return Observable<any>
   */
  public promptUserContextDialog(placeholder: ViewContainerRef, userContextFields: LMBannerUserContextField[]): Observable<LMApplicationMenuUserContextResult> {
    return new Observable<LMApplicationMenuUserContextResult>(observer => {
      this.lmLoggerService.log([ 'LMReportPersonalizationDialog', 'formService.getFormSpec()', 'Complete' ]);

      const userContextDialog$: Subject<LMApplicationMenuUserContextResult> = new Subject<LMApplicationMenuUserContextResult>();
      let dlgComponent: LMApplicationMenuUserContextDialogComponent;
      let dialog: SohoModalDialogRef<any>;

      const dialogId = 'ActorContext';
      const buttons = [
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CANCEL ]),
          text: Soho.Locale.translate(LMDialogButtonKey.CANCEL),
          click: (e, modal) => {
            modal.isCancelled = true;
            dialog.close(<LMApplicationMenuUserContextResult>{
              status: LMApplicationMenuUserContextDialogStatus.RESPONSE_CANCEL
            });
          }
        },
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.OK ]),
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          click: (e, modal) => {
            dialog.close(<LMApplicationMenuUserContextResult>{
              status:                LMApplicationMenuUserContextDialogStatus.RESPONSE_OK,
              userContextFields:     dlgComponent.userContextFields,
              userContextProperties: dlgComponent.model,
              saveChanges:           dlgComponent.saveChanges
            });
          },
          validate: false,
          isDefault: true
        }
      ];
      dialog = this.sohoModalDialogService
        .modal(LMApplicationMenuUserContextDialogComponent, placeholder, { fullsize: 'responsive' })
        .buttons(buttons)
        .title(Soho.Locale.translate('ActorContextDialogTitle'))
        .isAlert(false)
        .open()
        .apply((UserContextForm: LMApplicationMenuUserContextDialogComponent) => {
          dlgComponent = UserContextForm;
          if (userContextFields) {
            dlgComponent.userContextFields = userContextFields;
          }
          dlgComponent.dialog$ = userContextDialog$;
        })
        .afterClose(result => {
          observer.next(result);
          observer.complete();
        });

      userContextDialog$.subscribe((result: LMApplicationMenuUserContextResult) => {
        if (result.status === LMApplicationMenuUserContextDialogStatus.RESPONSE_SAVED) {
          userContextDialog$.complete();
          dialog.close(result);
        }
      });
    });
  }
}
